<template lang="pug">
app-page(:singleView="true")
  template(slot="content")
    h1 Settings
</template>

<script>
import Base from 'views/Base';

export default {
    name: 'Settings',

    extends: Base
};
</script>



// WEBPACK FOOTER //
// src/components/views/preferences/Settings.vue